import {SiteType} from "../js_env";

export class RecentCheckedItemJsEnv {
  siteType: SiteType;
  isLogin: boolean;
  recentCheckedItems: RecentCheckedItem[];
  hasRecentCheckedItems: boolean;

  constructor(
    siteType: SiteType,
    isLogin: boolean,
    recentCheckedItems: RecentCheckedItem[]
  ) {
    this.siteType = siteType;
    this.isLogin = isLogin;
    this.recentCheckedItems = recentCheckedItems;
    this.hasRecentCheckedItems = recentCheckedItems.length !== 0
  }
}

export class RecentCheckedItem {
  supplierId: string;
  catalogItemCode: string;
  imageUrl: string;
  itemName: string;

  constructor(
    supplierId: string,
    catalogItemCode: string,
    imageUrl: string,
    itemName: string) {
      this.supplierId = supplierId;
      this.catalogItemCode = catalogItemCode;
      this.imageUrl = imageUrl;
      this.itemName = itemName;
  }
}
